import { CSSObjectWithLabel, defaultTheme } from "chakra-react-select";

const { colors, spacing, borderRadius } = defaultTheme;

export const optionCSS = (
  isDisabled: boolean,
  isFocused: boolean,
  isSelected: boolean
): CSSObjectWithLabel => ({
  outline: "none",
  label: "option",
  cursor: "default",
  display: "block",
  fontSize: "inherit",
  width: "100%",
  userSelect: "none",
  WebkitTapHighlightColor: "rgba(0, 0, 0, 0)",
  backgroundColor: isSelected
    ? colors.primary
    : isFocused
    ? colors.primary25
    : "transparent",
  color: isDisabled
    ? colors.neutral20
    : isSelected
    ? colors.neutral0
    : "inherit",
  padding: `${spacing.baseUnit * 2}px ${spacing.baseUnit * 3}px`,
});

export const menuCSS = (): CSSObjectWithLabel => ({
  label: "menu",
  backgroundColor: colors.neutral0,
  borderRadius: borderRadius,
  boxShadow: "0 0 0 1px hsla(0, 0%, 0%, 0.1), 0 4px 11px hsla(0, 0%, 0%, 0.1)",
  marginBottom: spacing.menuGutter,
  marginTop: spacing.menuGutter,
  outline: "none",
});

export const menuListCSS = (): CSSObjectWithLabel => ({
  maxHeight: "200px",
  position: "relative",
  WebkitOverflowScrolling: "touch",
  paddingBottom: spacing.menuGutter,
  paddingTop: spacing.menuGutter,
  overflowY: "scroll",
});
